<template>
  <div
    :class="[
      'apollo__link',
      'breadcrumbs',
      `breadcrumbs--${direction}`,
      `breadcrumbs--${size}`,
      hover ? 'breadcrumbs--hover' : false,
    ]"
    @click.prevent="$goTo(voice.url, trans);"
  >
      <div
        class="breadcrumbs__line"
        data-anim="line"
        data-view="false"
      >
        <div class="breadcrumbs__line__inner breadcrumbs__line__inner--first" />
        <div class="breadcrumbs__line__inner breadcrumbs__line__inner--last" />
      </div>
      <a
        :href="voice.url"
        :aria-label="voice.label"
        class="breadcrumbs__link"
        data-anim="fade"
        data-view="false"
      >
        <Paragraph
          size="small"
          :text="voice.label"
        />
      </a>
  </div>
</template>

<script>
import Paragraph from '@/components/text/Paragraph.vue';

export default {
  name: 'Breadcrumbs',

  components: {
    Paragraph,
  },

  data() {
    return {
      anim: null,
    };
  },

  props: {
    voice: {
      type: Object,
      required: true,
    },

    direction: {
      type: String,
      required: true,
    },

    size: {
      type: String,
      required: false,
      default: 'medium',
    },

    trans: {
      type: String,
      required: false,
      default: 'default',
    },

    hover: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  mounted() {
  },

  methods: {
    enter(el, done) {
      done();
    },

    leave(el, done) {
      done();
    },
  }
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  display: grid;
  grid-template-areas: 'b a';
  grid-template-rows: 1fr;
  column-gap: rem(20px);
  align-items: baseline;
  cursor: pointer;

  * {
    pointer-events: none;
  }

  @include mq(ipadP) {
    column-gap: rem(20px);
  }

  @include mq(ds) {
    &.breadcrumbs--medium {
      column-gap: rem(40px);
    }
  }

  &--prev {
    grid-template-columns: rem(20px) 1fr;

    @include mq(ipadP) {
      grid-template-columns: rem(30px) 1fr;
    }

    @include mq(ds) {
      &.breadcrumbs--medium {
        grid-template-columns: rem(60px) 1fr;
      }
    }

    .breadcrumbs__line__inner {
      &--last {
        transform: translate3d(-102%, 0, 0);
      }
    }

    &:hover,
    &.breadcrumbs--hover {
      .breadcrumbs__line__inner {
        &--first {
          transform: translate3d(102%, 0, 0);
        }
      }
    }
  }

  &--next {
    grid-template-columns: 1fr rem(20px);

    @include mq(ipadP) {
      grid-template-columns: 1fr rem(30px);
    }

    @include mq(ds) {
      grid-template-columns: 1fr rem(60px);
    }

    .breadcrumbs__line {
      order: 1;
    }
    
    .breadcrumbs__link {
      order: 0;
    }

    .breadcrumbs__line__inner {
      &--last {
        transform: translate3d(102%, 0, 0);
      }
    }

    &:hover,
    &.breadcrumbs--hover {
      .breadcrumbs__line__inner {
        &--first {
          transform: translate3d(-102%, 0, 0);
        }
      }
    }
  }

  &__line {
    position: relative;
    width: rem(20px);
    height: 1px;
    overflow: hidden;

    @include mq(ipadP) {
      width: rem(30px);
    }

    @include mq(ds) {
      @at-root .breadcrumbs--medium & {
        width: rem(60px);
      }
    }

    &__inner {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: $color-dark-light;
      transition: transform .8s $outExpo;

      &--first {
        transform: translate3d(0%, 0, 0);

        transition-delay: .4s;
      }

      &--last {
        transform: translate3d(-102%, 0, 0);
      }
    }
  }

  &__link {
    * {
      pointer-events: none;
    }
  }

  &:hover,
  &.breadcrumbs--hover {
    .breadcrumbs__line__inner {
      &--first {
        transition-delay: 0s;
      }

      &--last {
        transform: translate3d(0%, 0, 0);
        transition-delay: .4s;
      }
    }
  }
}
</style>
